import { classNames } from "../utils";

const Input = (props: React.InputHTMLAttributes<HTMLInputElement>) => {
  const { className, ...rest } = props;
  return (
    <div className="flex items-center">
      <input
        {...rest}
        type="text"
        className={classNames(
          "text-sm font-medium text-gray-500 h-10 pr-8 pl-5 rounded z-0 border border-gray-300 focus:outline-none",
          className || "w-96"
        )}
      />
      <label htmlFor="checkbox" className="sr-only">
        checkbox
      </label>
    </div>
  );
};
export default Input;
